var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{directives:[{name:"t",rawName:"v-t",value:('general.button.download'),expression:"'general.button.download'"}],attrs:{"href":_vm.link}})}
var staticRenderFns = []

export { render, staticRenderFns }